@for (keyValue of getFundGeneralInfo() | keyvalue: sortStatistic; track keyValue; let last = $last) {
  <div
    class="w-100 d-grid"
    [ngClass]="{ 'pb-medium': !last }"
  >
    <span class="c-1 text-onback-high">
      @if (keyValue.key === 'netAsset') {
        خالص ارزش دارایی صندوق
      } @else if (keyValue.key === 'statisticNav') {
        قیمت آماری
      } @else if (keyValue.key === 'website') {
        وبسایت صندوق
      } @else if (keyValue.key === 'type') {
        نوع صندوق
      }
    </span>
    <div class="c-1 text-onback-medium d-flex align-items-center gap-tiny justify-content-end">
      @if (keyValue.key === 'netAsset' || keyValue.key === 'statisticNav') {
        @if (keyValue.value !== '0') {
          {{ keyValue.value | thousands }} ریال
        } @else {
          ندارد
        }
        @if (keyValue.key === 'statisticNav') {
          <ngx-button
            [classNames]="['w-fit-content']"
            [mode]="'icon-only'"
            [style]="'link'"
            [size]="'small'"
            [rightIcon]="{
              name: 'question-mark-circle',
            }"
            [ngxTooltip]="'ارزش خالص تعدیل نشده هر واحد'"
            [tooltipPosition]="'top-right'"
            [disableArrow]="true"
            [tooltipType]="'click'"
            [closeTimeout]="3000"
          />
        }
      } @else if (keyValue.key === 'website') {
        {{ keyValue.value }}
      } @else {
        {{ fund().investmentType === 'Mutual' ? 'صدور/ابطالی' : 'قابل معامله' }}
        -
        {{
          keyValue.value === 'FixedIncome'
            ? 'درامد ثابت'
            : keyValue.value === 'Gold'
              ? 'مبتنی بر طلا'
              : keyValue.value === 'Index'
                ? 'شاخصی'
                : 'سهامی'
        }}
      }
    </div>
  </div>

  @if (!last) {
    <ngx-divider
      class="w-100 mb-medium"
      [color]="BorderColorsEnum.Light"
      orientation="horizontal"
    />
  }
}
